import { render } from "./CuImgView.vue?vue&type=template&id=4cb132b8"
import script from "./CuImgView.vue?vue&type=script&lang=js"
export * from "./CuImgView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__